// extracted by mini-css-extract-plugin
export default {"content_bg":"services_content_bg__Tdz2P","title":"services_title__vdKIc","para1":"services_para1__RewZG"};